module.exports = __webpack_public_path__ + "static/media/modelPhoto.f5c2701c.png";